import { User } from "oidc-client-ts"
import { usePermissionsOptimized } from "ra-core"
import { USER_STORAGE_KEY } from "./odUserManager"
import { useMemo } from "react"
import { parseAccessToken } from "./jwtDecode"
import { AccessTokenClaims } from "./odUserManager"
import { Permissions_new } from "@/constants"

// perfer useOdPermissions() instead of usePermissions, usePermissionsOptimized:
//   permits are retrieved from access_token which is stored in localstorage;
//   the retrieving process can be synchronous instead of asynchronous,
//   thus no need to handle state in between when permits are not determined,
//   (it always will be determined as long as user is logged in)
export const useOdPermissions = () => {
  const { permissions } = usePermissionsOptimized()
  return useMemo(() => {
    const ps = new Set<Permissions_new>((permissions ?? ((()=>{
      // when usePermissionsOptimized() initially load, it will return undefined
      // then we have to read permissions directly from the access_token stored in localStorage
      const user = User.fromStorageString(
        window.localStorage.getItem('oidc.' + USER_STORAGE_KEY) ?? '{}'
      )
      if (!user.access_token) { return [] }
      const jwtAt = parseAccessToken<AccessTokenClaims>(user.access_token).payload
      return (!jwtAt || !jwtAt.permissions) ? []
      : jwtAt.permissions instanceof Array  ? jwtAt.permissions
      : [jwtAt.permissions]
    })())))
    return ps
  }, [permissions])
}


